import { render, staticRenderFns } from "./e-empty-placeholder.vue?vue&type=template&id=b85c26b8&scoped=true"
import script from "./e-empty-placeholder.vue?vue&type=script&lang=js"
export * from "./e-empty-placeholder.vue?vue&type=script&lang=js"
import style0 from "./e-empty-placeholder.vue?vue&type=style&index=0&id=b85c26b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85c26b8",
  null
  
)

export default component.exports